module.exports = __webpack_public_path__ + "static/mobile@2x-300x248-4c90afd1405a5c34e7b8f7b60dc353ea.png";